import React, { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardLayout from '../../components/Dashboard/DashboardLayout';
import SidebarWithAccordion from '../../components/Dashboard/SidebarWithAccordion';
import { createStudentSidebarConfig } from '../../components/Dashboard/StudentSidebarConfig';
import { AuthContext } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

/**
 * StudentLayout - 学生页面的共享布局组件
 * 包含统一的侧边栏导航和布局
 */
function StudentLayout({ 
  appBarTitle, 
  appBarActions, 
  children,
  categories = [],
  selectedCategory = 'all',
  onCategoryChange,
  categoriesOpen = true,
  onToggleCategories,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, selectedCourse, logout } = useContext(AuthContext);
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Drawer content - Use shared sidebar config
  const sidebarConfig = createStudentSidebarConfig({
    navigate,
    user,
    selectedCourse,
    onLogout: handleLogout,
    t,
    categories,
    selectedCategory,
    onCategoryChange: (cat) => {
      if (cat === 'all') {
        navigate('/questions');
      } else {
        navigate(`/questions/category/${encodeURIComponent(cat)}`);
      }
      if (onCategoryChange) {
        onCategoryChange(cat);
      }
    },
    currentPath: location.pathname
  });

  const handleSettingsClick = () => {
    navigate('/settings');
  };

  const drawerContent = (
    <SidebarWithAccordion {...sidebarConfig} onSettingsClick={handleSettingsClick} />
  );

  return (
    <DashboardLayout
      drawerContent={drawerContent}
      appBarTitle={appBarTitle}
      appBarActions={appBarActions}
      courseName={selectedCourse?.name}
      courseTermCode={selectedCourse?.termCode}
      mobileOpen={mobileOpen}
      onDrawerToggle={handleDrawerToggle}
      onLogout={handleLogout}
    >
      {children}
    </DashboardLayout>
  );
}

export default StudentLayout;
